import { Pipe, PipeTransform } from '@angular/core';
import { StringHHmm } from '@concretecode/shared';

@Pipe({
  name: 'hhmmSplit',
})
export class HHmmSplitPipe implements PipeTransform {
  // 'HHmm' => 'HH' or 'mm'
  transform(value: StringHHmm | string | undefined, part?: 'hours' | 'minutes'): string {
    if (!value || value.length !== 4) {
      return part === 'hours' ? '00' : part === 'minutes' ? '00' : '00:00';
    }

    const hours = value.substring(0, 2);
    const minutes = value.substring(2, 4);

    if (part === 'hours') {
      return hours;
    }
    if (part === 'minutes') {
      return minutes;
    }

    return `${hours}:${minutes}`;
  }
}
